__turbopack_context__.v({
  "link": "Link-module-scss-module__g_UdlW__link",
});
